<script setup lang="ts">
import { MMIcon, MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';
import { InputMasked, ButtonPrimaryAccented, snackBarManager } from '~/features/ui-kit';
import { useSignIn } from '../business/useSignIn';
import PrivacyPolicy from './PrivacyPolicy.vue';

const { signInPhoneStep } = useSignIn();
const { phoneStepForm, isLoading, isFormValid, handleSubmit, formData, renderCaptcha } = signInPhoneStep;

onMounted(() => {
  phoneStepForm.reset();
  renderCaptcha();
});
</script>

<template>
  <MMPopupDefault class="popup">
    <template #header>
      <MMIcon name="magnit-id-logo" class="popup-header__logo" />
      <MMText font="Title L/Semibold" label="Введите номер телефона" class="popup-header__title" />
      <MMText font="Body L/Regular" label="Отправим смс с кодом подтверждения" />
    </template>

    <div class="popup-content">
      <InputMasked
        v-model="formData.phone.value"
        placeholder="+7 000 000-00-00"
        mask="+{7} (000) 000-00-00"
        is-required
        is-filled
        size="l48"
        class="popup-content__input"
        :disabled="isLoading"
      />
      <div id="yandex-captcha-phone" />
    </div>

    <template #footer>
      <PrivacyPolicy class="popup-footer__privacy-policy" />
      <ButtonPrimaryAccented 
        w100
        size="l48"
        class="popup-footer__button"
        :disabled="!isFormValid"
        :loading="isLoading"
        @click="handleSubmit"
      >
        Получить код
      </ButtonPrimaryAccented>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.popup
  width 480px

  +Media(Mobile)
    max-width calc(100vw - 32px)

.popup-header
  &__logo
    display flex
    justify-content flex-start
    margin-bottom 30px

  &__title
    margin-bottom 6px

.popup-content
  margin-top 28px
  margin-bottom 26px
  display flex
  flex-direction column
  gap 36px

.popup-footer
  &__button
    margin-top 20px
</style>